// src/components/device/DeviceOverview.jsx
import React from "react";
import { Grid, Card, CardContent, Typography, Stack, Chip } from "@mui/material";

export default function DeviceOverview({ device }) {
  const live = device?.liveData || {};

  const items = [
    { k: "Status", v: String(device?.status || "-").toUpperCase() },
    { k: "Vehicle", v: live?.vehicleStatus || "-" },
    { k: "ACC", v: live?.accStatus ? "ON" : "OFF" },
    { k: "Speed", v: `${live?.speed ?? 0} km/h` },
    { k: "Last Seen", v: device?.lastDataReceivedAt ? new Date(device.lastDataReceivedAt).toLocaleString() : "-" },
    { k: "IMEI", v: device?.imei || "-" },
  ];

  return (
    <Grid container spacing={2}>
      {items.map((it) => (
        <Grid key={it.k} item xs={12} sm={6} md={4}>
          <Card sx={{ borderRadius: 3, height: "100%" }}>
            <CardContent>
              <Stack spacing={0.75}>
                <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 800 }}>
                  {it.k}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 900 }}>
                  {it.v}
                </Typography>

                {it.k === "Status" && (
                  <Chip
                    size="small"
                    label={(device?.status || "unknown").toUpperCase()}
                    color={(device?.status || "").toLowerCase() === "online" ? "success" : "default"}
                    variant={(device?.status || "").toLowerCase() === "online" ? "filled" : "outlined"}
                    sx={{ width: "fit-content" }}
                  />
                )}
              </Stack>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
